const ProductsTabItem = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="25"
            viewBox="0 0 26 25"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_531_277)">
                <path
                    d="M14.9082 14.1978L23.1578 22.4473"
                    stroke="#686058"
                    strokeWidth="3.36007"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M3.21048 2.58545C-4.59248 10.9795 16.3665 15.6561 16.3665 15.6561C16.3665 15.6561 2.82952 10.7299 3.21048 2.58545Z"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.32202 2.48671C11.7161 -5.31625 16.3664 15.6558 16.3664 15.6558C16.3664 15.6558 11.4665 2.10576 3.32202 2.48671Z"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3664 15.6561L3.21045 2.58545"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.36959 15.0515L4.18896 17.2256L9.00998 22.0532L13.3318 17.7313"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3269 5.0942L18.5075 2.91357L23.3285 7.73459L19.0067 12.0499"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.58147 18.8218L3.3483 21.0549C2.84256 21.5607 2.84256 22.3817 3.3483 22.8875C3.85405 23.3932 4.67507 23.3932 5.18082 22.8875L7.47967 20.5886"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.3171 5.81682L24.5503 3.58365C25.0561 3.0779 25.0561 2.25688 24.5503 1.75114C24.0446 1.24539 23.2235 1.24539 22.7178 1.75114L20.4189 4.04999"
                    stroke="#686058"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_531_277">
                    <rect
                        width="24.7685"
                        height="24"
                        fill="white"
                        transform="translate(0.812988 0.0893555)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ProductsTabItem
